import { render, staticRenderFns } from "./CampaignRuleManager.vue?vue&type=template&id=2b567b72&scoped=true&"
import script from "./CampaignRuleManager.vue?vue&type=script&lang=js&"
export * from "./CampaignRuleManager.vue?vue&type=script&lang=js&"
import style0 from "./CampaignRuleManager.vue?vue&type=style&index=0&id=2b567b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b567b72",
  null
  
)

export default component.exports